import AccountInformation from "../../components/AccountInformation/AccountInformation";

const AccountInformationPage = () => {
  return <AccountInformation />;
};

export default AccountInformationPage;
